export const SHOW_DETAILS_STATE_KEY = 'signup:showDetails';
export const CONFIG_KEY = 'signup:config';

export const getShowDetails = () => {
  try {
    return JSON.parse(sessionStorage.getItem(SHOW_DETAILS_STATE_KEY) || 'false');
  } catch {
    return false;
  }
};

export const setShowDetails = (value = true) => {
  sessionStorage.setItem(SHOW_DETAILS_STATE_KEY, JSON.stringify(value));
};
